import mainImg from "../../../assets/skirting-gold.webp"; 
import thumb1 from "../../../assets/skirting-gold.webp";
import thumb2 from "../../../assets/skirting-gold.webp";

import mainImgone from "../../../assets/skirting-silver.webp"; 
import thumb3 from "../../../assets/skirting-silver.webp";
import thumb4 from "../../../assets/skirting-silver.webp";


import mainImgtwo from "../../../assets/skirting-black.webp"; 
import thumb5 from "../../../assets/skirting-black.webp";
import thumb6 from "../../../assets/skirting-black.webp";

import mainImgthree from "../../../assets/led-skirting.png"; 
import thumb7 from "../../../assets/led-skirting.png";
import thumb8 from "../../../assets/led-skirting.png";

import mainImgfour from "../../../assets/flexible-skirting.jpg"; 
import thumb9 from "../../../assets/flexible-skirting.jpg";
import thumb10 from "../../../assets/flexible-skirting.jpg";

import mainImgfive from "../../../assets/skirting-connectr-black.webp"; 
import thumb11 from "../../../assets/skirting-connectr-black.webp";
import thumb12 from "../../../assets/skirting-connectr-black.webp";

import mainImgsix from "../../../assets/j-gola.png"; 
import thumb13 from "../../../assets/j-gola.png";
import thumb14 from "../../../assets/j-gola.png";

import mainImgseven from "../../../assets/c-gola.webp";
import thumb15 from "../../../assets/c-gola.webp";
import thumb16 from "../../../assets/c-gola.webp";


import mainImg8 from "../../../assets/pvc-leg-heavy.webp"; 
import thumb17 from "../../../assets/pvc-leg-heavy.webp";
import thumb18 from "../../../assets/pvc-leg-heavy.webp";

import mainImg9 from "../../../assets/pvc-leg-light.webp"; 
import thumb19 from "../../../assets/pvc-leg-light.webp";
import thumb20 from "../../../assets/pvc-leg-light.webp";

import mainImg10 from "../../../assets/dish-holder.webp"; 
import thumb21 from "../../../assets/dish-holder.webp";
import thumb22 from "../../../assets/dish-holder.webp";


import mainImg11 from "../../../assets/wire-fitment-with-pvc-grip.webp"; 
import thumb23 from "../../../assets/wire-fitment-with-pvc-grip.webp";
import thumb24 from "../../../assets/wire-fitment-with-pvc-grip.webp";

import mainImg12 from "../../../assets/unbreakble-cutlery.webp"; 
import thumb25 from "../../../assets/unbreakble-cutlery.webp";
import thumb26 from "../../../assets/unbreakble-cutlery.webp";


import mainImg13 from "../../../assets/cutlery.jpg"; 
import thumb27 from "../../../assets/cutlery.jpg";
import thumb28 from "../../../assets/cutlery.jpg";

import mainImg14 from "../../../assets/ss-wire-fitment.webp"; 
import thumb29 from "../../../assets/ss-wire-fitment.webp";
import thumb30 from "../../../assets/ss-wire-fitment.webp";

import mainImg15 from "../../../assets/silver-dish-rack.webp"; 
import thumb31 from "../../../assets/silver-dish-rack.webp";
import thumb32 from "../../../assets/silver-dish-rack.webp";

import mainImg16 from "../../../assets/black-dish-rack.jpeg"; 
import thumb34 from "../../../assets/black-dish-rack.jpeg";
import thumb33 from "../../../assets/black-dish-rack.jpeg";

import mainImg17 from "../../../assets/auto-lid-bin.webp"; 
import thumb35 from "../../../assets/auto-lid-bin.webp";
import thumb36 from "../../../assets/auto-lid-bin.webp";

export const products = [
  
 {
  code: "7638",
  name: "SKIRTING GOLD",
  category: "kitchen Accessories",

  short:
    "Skirting Gold is a premium decorative accessory designed to enhance the finish and protection of modular kitchen cabinets and furniture edges. Featuring a stylish gold finish, it not only improves the aesthetic appeal of interiors but also protects cabinet bases from dust, moisture, and daily wear. Ideal for modern kitchens and furniture systems, it offers durability, elegance, and easy maintenance.",

  features: [
    "Premium gold finish for a luxurious look",
    "Protects cabinet base from dust & moisture",
    "Strong, durable & long-lasting build",
    "Enhances modular kitchen aesthetics",
    "Easy to clean & maintain"
  ],

  /* ✅ PRICE */
  price: "₹580",
  oldPrice: "₹650",

  /* ✅ SKU + STOCK */
  sku: "7650",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg,
  thumbnails: [thumb1, thumb2],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Skirting%20Gold",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Aluminium / Metal" },
    { label: "Finish", value: "Gold" },
    { label: "Application", value: "Modular Kitchen / Cabinets" },
    { label: "Usage", value: "Base Protection & Decoration" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Skirting Gold", code: "7650", size: "100mm", finish: "Gold" },
      
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Skirting Gold?",
      answer:
        "It is a decorative and protective skirting used at the base of modular kitchen cabinets and furniture."
    },
    {
      question: "Where can Skirting Gold be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, and furniture bases for protection and decoration."
    },
    {
      question: "Does it protect cabinets?",
      answer:
        "Yes, it protects cabinet bases from dust, moisture, and daily wear."
    },
    {
      question: "Is the gold finish durable?",
      answer:
        "Yes, it is designed with a durable finish to maintain its look over time."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed with standard fittings in modular kitchen setups."
    }
  ]
},
  
 {
  code: "7522",
  name: "SKIRTING SILVER",
  category: "kitchen Accessories",

  short:
    "Skirting Silver is a stylish and functional accessory designed for the base of modular kitchen cabinets and furniture units. With its elegant silver finish, it enhances the overall appearance of interiors while protecting cabinet bases from dust, moisture, and everyday wear. Built with durable materials, it provides long-lasting performance and a clean, modern look for modular kitchen setups.",

  features: [
    "Elegant silver finish for modern look",
    "Protects cabinet base from dust & moisture",
    "Strong, durable & long-lasting",
    "Enhances modular kitchen appearance",
    "Easy installation & maintenance",
    "Available Sizes: 100mm, 150mm"
  ],

  /* ✅ PRICE */
  price: "₹554",
  oldPrice: "₹600",

  /* ✅ SKU + STOCK */
  sku: "7522",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgone,
  thumbnails: [thumb3, thumb4],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Skirting%20Silver",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Aluminium / Metal" },
    { label: "Finish", value: "Silver" },
    { label: "Sizes", value: "100mm, 150mm" },
    { label: "Application", value: "Modular Kitchen / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Skirting Silver", code: "7522", size: "100mm", finish: "Silver" },
    { item: "Skirting Silver", code: "7523", size: "150mm", finish: "Silver" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Skirting Silver?",
      answer:
        "It is a decorative and protective skirting used at the base of modular kitchen cabinets and furniture."
    },
    {
      question: "Where can Skirting Silver be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, and furniture bases for protection and decoration."
    },
    {
      question: "Does it protect cabinets?",
      answer:
        "Yes, it protects cabinet bases from dust, moisture, and daily wear."
    },
    {
      question: "Is the silver finish durable?",
      answer:
        "Yes, it is designed with a durable finish to maintain its appearance over time."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed with standard fittings in modular kitchen setups."
    }
  ]
},
  


  {
  code: "7644",
  name: "SKIRTING BLACK",
  category: "kitchen Accessories",

  short:
    "Skirting Black is a modern and durable accessory designed for the base of modular kitchen cabinets and furniture units. With its sleek black finish, it enhances the overall look of interiors while protecting cabinet bases from dust, moisture, and everyday wear. It provides a clean and professional finish while ensuring long-lasting performance in modern kitchen setups.",

  features: [
    "Stylish black finish for modern look",
    "Protects cabinet base from dust & moisture",
    "Strong, durable & long-lasting build",
    "Perfect for modular kitchens & furniture",
    "Enhances overall interior appearance",
    "Easy to install & maintain"
  ],

  /* ✅ PRICE */
  price: "₹554",
  oldPrice: "₹650",

  /* ✅ SKU + STOCK */
  sku: "7524",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgtwo,
  thumbnails: [thumb5, thumb6],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Skirting%20Black",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Aluminium / Metal" },
    { label: "Finish", value: "Black" },
    { label: "Application", value: "Modular Kitchen / Cabinets" },
    { label: "Usage", value: "Base Protection & Decoration" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Skirting Black", code: "7524", size: "100mm", finish: "Black" },
    { item: "Skirting Black", code: "7525", size: "150mm", finish: "Black" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Skirting Black?",
      answer:
        "It is a protective and decorative skirting used at the base of modular kitchen cabinets and furniture."
    },
    {
      question: "Where can Skirting Black be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, and furniture bases for protection and decoration."
    },
    {
      question: "Does it protect cabinets?",
      answer:
        "Yes, it protects cabinet bases from dust, moisture, and daily wear."
    },
    {
      question: "Is the black finish durable?",
      answer:
        "Yes, it is designed with a durable finish that maintains its look for a long time."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard fittings in modular kitchen setups."
    }
  ]
},
  
  
 {
  code: "7126",
  name: "LED SKIRTING SILVER & BLACK",
  category: "kitchen Accessories",

  short:
    "LED Skirting (Silver & Black) is a modern modular kitchen accessory designed to enhance both functionality and aesthetics. It features built-in LED lighting along with durable skirting that protects cabinet bases from dust, moisture, and damage. Available in stylish silver and black finishes, it creates a premium illuminated look while providing a clean and professional finish for modular kitchens and furniture units.",

  features: [
    "Built-in LED lighting for premium look",
    "Available in Silver & Black finishes",
    "Enhances kitchen visibility at night",
    "Protects cabinet base from dust & moisture",
    "Durable & long-lasting construction",
    "Modern illuminated modular kitchen design"
  ],

  /* ✅ PRICE */
  price: "₹1013",
  oldPrice: "₹1200",

  /* ✅ SKU + STOCK */
  sku: "7126",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgthree,
  thumbnails: [thumb7, thumb8],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20LED%20Skirting",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Aluminium / Metal" },
    { label: "Finish", value: "Silver / Black" },
    { label: "Lighting", value: "LED Integrated" },
    { label: "Application", value: "Modular Kitchen / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "LED Skirting", code: "7651", size: "100mm", finish: "Silver" },
    { item: "LED Skirting", code: "7652", size: "100mm", finish: "Black" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is LED Skirting?",
      answer:
        "LED Skirting is a cabinet base accessory with built-in LED lighting that enhances the look of modular kitchens while protecting cabinet bases."
    },
    {
      question: "Which finishes are available in LED Skirting?",
      answer:
        "LED Skirting is available in stylish Silver and Black finishes."
    },
    {
      question: "What is the purpose of LED Skirting?",
      answer:
        "It provides decorative lighting and protects cabinet bases from dust, moisture, and damage."
    },
    {
      question: "Where can LED Skirting be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, and furniture bases."
    },
    {
      question: "Is LED Skirting easy to install?",
      answer:
        "Yes, it can be installed easily with standard fittings and LED connections."
    }
  ]
},
  
{
  code: "7653",
  name: "FLEXIBLE SKIRTING CONNECTOR PVC BACK & SILVER & Gold",
  category: "kitchen Accessories",

  short:
    "The Flexible Skirting Connector (PVC Back & Silver) is a practical accessory used to join and align modular kitchen skirting sections smoothly. Its flexible design allows easy connection around corners and uneven surfaces while maintaining a neat finish. Made with a durable PVC back and stylish silver front, it helps protect cabinet bases from dust, moisture, and daily wear while ensuring a clean and professional look.",

  features: [
    "Flexible design for smooth skirting connection",
    "Durable PVC back with premium silver finish",
    "Perfect for corner joints & uneven layouts",
    "Ensures seamless alignment between panels",
    "Protects cabinet base from dust & moisture",
    "Strong, durable & long-lasting",
    "Easy installation & maintenance",
    "Angle Support: 180°"
  ],

  /* ✅ PRICE */
  price: "₹36",
  oldPrice: "₹80",

  /* ✅ SKU + STOCK */
  sku: "7653",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgfour,
  thumbnails: [thumb9, thumb10],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Flexible%20Skirting%20Connector",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC Back + Metal Front" },
    { label: "Finish", value: "Silver" },
    { label: "Size", value: "100mm" },
    { label: "Angle", value: "180°" },
    { label: "Application", value: "Modular Kitchen Skirting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Flexible Skirting Connector", code: "7653", size: "100mm & 180°", finish: "Black", },
    { item: "Flexible Skirting Connector", code: "7654", size: "100mm & 180°", finish: "Silver",  },
    { item: "Flexible Skirting Connector", code: "7655", size: "100mm & 180°", finish: "Golden",  }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Flexible Skirting Connector?",
      answer:
        "It is an accessory used to join and align modular kitchen skirting panels smoothly."
    },
    {
      question: "What materials are used in this connector?",
      answer:
        "It features a durable PVC back with a stylish silver finish on the front."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in modular kitchens to connect skirting panels around corners or joints."
    },
    {
      question: "Does it help protect cabinet bases?",
      answer:
        "Yes, it helps maintain a sealed skirting line that protects cabinet bases from dust, moisture, and daily wear."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, the flexible design allows quick and easy installation in modular kitchen setups."
    }
  ]
},
  
  
  {
  code: "7656",
  name: "SKIRTING CONNECTOR PVC BACK (SILVER / GOLDEN)",
  category: "kitchen Accessories",

  short:
    "The Skirting Connector (PVC Back, Silver, Golden) is a durable accessory designed to join modular kitchen skirting panels neatly and securely. With a strong PVC back and stylish silver or golden finish, it ensures proper alignment between skirting sections while enhancing the overall look of kitchen cabinets. It helps maintain a clean finish and protects cabinet bases from dust, moisture, and daily wear.",

  features: [
    "Durable PVC back for strong support",
    "Available in Silver & Golden finishes",
    "Ensures smooth connection between panels",
    "Maintains proper skirting alignment",
    "Protects cabinet base from dust & moisture",
    "Strong, durable & long-lasting",
    "Easy installation & maintenance",
    "Angle Support: 90°"
  ],

  /* ✅ PRICE */
  price: "₹110",
  oldPrice: "₹160",

  /* ✅ SKU + STOCK */
  sku: "7656",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgfive,
  thumbnails: [thumb11, thumb12],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Skirting%20Connector",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC Back + Metal Front" },
    { label: "Finish", value: "Silver / Golden / Black " },
    { label: "Size", value: "100mm" },
    { label: "Angle", value: "90°" },
    { label: "Application", value: "Modular Kitchen Skirting" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Skirting Connector", code: "7656", size: "100mm & 90°", finish: "Black"},
    { item: "Skirting Connector", code: "7657", size: "100mm & 90°", finish: "Sliver"},
    { item: "Skirting Connector", code: "7658", size: "100mm & 90°", finish: "Golden"}
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Skirting Connector?",
      answer:
        "It is an accessory used to join and align modular kitchen skirting panels securely."
    },
    {
      question: "Which finishes are available?",
      answer:
        "It is available in Silver and Golden finishes with a durable PVC back."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in modular kitchens to connect cabinet skirting panels."
    },
    {
      question: "Does it protect cabinet bases?",
      answer:
        "Yes, it helps maintain a sealed skirting line that protects cabinet bases from dust and moisture."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed during modular kitchen skirting installation."
    }
  ]
},
  

   {
  code: "7129",
  name: "J HANDLE",
  category: "kitchen Accessories",

  short:
    "PVC J Gola is a modern handle-less profile used in modular kitchens and furniture to create a sleek and seamless cabinet opening system. Made from durable PVC material, it allows easy grip for opening drawers and cabinet shutters without the need for external handles. It enhances the overall appearance of interiors while providing a clean, minimalistic, and contemporary look.",

  features: [
    "High-quality durable PVC material",
    "Handle-less cabinet & drawer system",
    "Smooth grip for easy opening",
    "Modern & minimal kitchen design",
    "Moisture & corrosion resistant",
    "Long-lasting daily performance",
    "Ideal for kitchens, wardrobes & furniture"
  ],

  /* ✅ PRICE */
  price: "₹1199",
  oldPrice: "₹2000",

  /* ✅ SKU + STOCK */
  sku: "8011",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgsix,
  thumbnails: [thumb13, thumb14],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20J%20Gola",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "J Gola Profile" },
    { label: "Finish", value: "Matt Black/ Rose Gold" },
    { label: "Application", value: "Modular Kitchen / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC J Gola", code: "8011", size: " MATT BLACK / ROSE GOLD", finish: "PVC" },
     { item: "PVC J Gola", code: "8012", size: " ROSE GOLD", finish: "PVC" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is PVC J Gola?",
      answer:
        "PVC J Gola is a handle-less profile used in modular kitchens to open drawers and cabinets without external handles."
    },
    {
      question: "Where can PVC J Gola be used?",
      answer:
        "It is mainly used in modular kitchens, wardrobes, and furniture cabinets."
    },
    {
      question: "What is the benefit of using J Gola?",
      answer:
        "It provides a clean handle-less design and makes cabinets easier to open with a built-in grip."
    },
    {
      question: "Is PVC J Gola durable?",
      answer:
        "Yes, it is made from high-quality PVC that is resistant to moisture and daily wear."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in modular kitchen cabinet systems."
    }
  ]
},
{
  code: "7129",
  name: " C GOLA",
  category: "kitchen Accessories",

  short:
    " C Gola is a modern handle-less profile used in modular kitchens and furniture to create a sleek and seamless cabinet opening system. Made from durable PVC material, it allows easy grip for opening drawers and cabinet shutters without external handles. It enhances interiors with a clean, minimal and premium look.",

  /* ✅ PRICE */
  price: "₹1522",
  oldPrice: "₹2000",

  /* ✅ SKU + STOCK */
  sku: "8011",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImgseven,
  thumbnails: [thumb15, thumb16],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20C%20Gola",

  /* ✅ FEATURES */
  features: [
    "High-quality durable PVC material",
    "Handle-less cabinet & drawer system",
    "Smooth grip for easy opening",
    "Modern & minimal kitchen design",
    "Moisture & corrosion resistant",
    "Long-lasting daily performance",
    "Ideal for kitchens, wardrobes & furniture"
  ],

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "C Gola Profile" },
    { label: "Finish", value: "Matt Black / Rose Gold" },
    { label: "Application", value: "Modular Kitchen / Cabinets / Furniture" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC C Gola", code: "8008", size: "Matt Black", finish: "PVC" },
    { item: "PVC C Gola", code: "8010", size: "Rose Gold", finish: "PVC" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is PVC C Gola?",
      answer:
        "PVC C Gola is a handle-less profile used in modular kitchens for smooth opening of cabinets and drawers without external handles."
    },
    {
      question: "Where is C Gola used?",
      answer:
        "It is mainly used in modular kitchens, wardrobes, and furniture systems."
    },
    {
      question: "What are its benefits?",
      answer:
        "It gives a modern handle-less design, clean look, and easy grip for opening cabinets."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality PVC which is moisture resistant and long lasting."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed in modular kitchen cabinet systems."
    }
  ]
},

  {
  code: "7131",
  name: "PVC LEG HEAVY",
  category: "kitchen Accessories",

  short:
    "PVC Leg Heavy is a strong and durable support accessory designed for modular kitchen cabinets and furniture units. Made from high-quality PVC, it provides excellent load-bearing capacity and stability, ensuring cabinets remain balanced and secure. Its adjustable design helps maintain proper height alignment while protecting furniture bases from moisture and floor contact.",

  /* ✅ PRICE */
  price: "₹32",
  oldPrice: "₹50",

  /* ✅ SKU + STOCK */
  sku: "7659",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg8,
  thumbnails: [thumb17, thumb18],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20Leg%20Heavy",

  /* ✅ FEATURES */
  features: [
    "Made from high-quality heavy-duty PVC for strength and durability.",
    "Provides strong support for modular kitchen cabinets and furniture.",
    "High load-bearing capacity for heavy cabinet structures.",
    "Adjustable height for proper cabinet alignment.",
    "Resistant to moisture, corrosion, and daily wear.",
    "Ideal for modular kitchens, wardrobes, and storage units."
  ],

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Heavy Duty PVC" },
    { label: "Type", value: "Cabinet Support Leg" },
    { label: "Load Capacity", value: "Heavy Duty" },
    { label: "Application", value: "Modular Kitchen / Cabinets / Furniture" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC Leg Heavy", code: "7759", size: "", finish: "PVC" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is PVC Leg Heavy?",
      answer:
        "PVC Leg Heavy is a strong support leg used for modular kitchen cabinets and furniture bases."
    },
    {
      question: "Where can PVC Leg Heavy be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, wardrobes, and storage furniture."
    },
    {
      question: "Does it support heavy cabinets?",
      answer:
        "Yes, it is designed with heavy-duty PVC to provide high load-bearing capacity."
    },
    {
      question: "Is the height adjustable?",
      answer:
        "Yes, PVC Leg Heavy comes with adjustable height for proper cabinet alignment."
    },
    {
      question: "Is it resistant to moisture?",
      answer:
        "Yes, PVC material is resistant to moisture, corrosion, and daily wear."
    }
  ]
},


  {
  code: "7132",
  name: "PVC LEG LIGHT",
  category: "kitchen Accessories",

  short:
    "PVC Leg Light is a lightweight and durable support accessory designed for modular kitchen cabinets and furniture units. Made from quality PVC material, it provides stable support and proper elevation for cabinets while protecting them from direct floor contact. Its adjustable design ensures easy leveling and alignment, making it ideal for modern modular kitchen setups.",

  /* ✅ PRICE */
  price: "₹22",
  oldPrice: "₹45",

  /* ✅ SKU + STOCK */
  sku: "7660",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg9,
  thumbnails: [thumb19, thumb20],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/Cxra4zcJaUs",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20Leg%20Light",

  /* ✅ FEATURES */
  features: [
    "Made from high-quality lightweight PVC material.",
    "Provides stable support for cabinets and furniture.",
    "Adjustable height for proper leveling and alignment.",
    "Resistant to moisture and corrosion.",
    "Ideal for modular kitchens, wardrobes, and storage units.",
    "Helps protect cabinet bases from floor contact."
  ],

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Lightweight PVC" },
    { label: "Type", value: "Cabinet Support Leg" },
    { label: "Load Capacity", value: "Light to Medium Duty" },
    { label: "Application", value: "Modular Kitchen / Cabinets / Furniture" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC Leg Light", code: "7660", size: "", finish: "PVC" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is PVC Leg Light?",
      answer:
        "PVC Leg Light is a lightweight support leg used for modular kitchen cabinets and furniture bases."
    },
    {
      question: "Where can PVC Leg Light be used?",
      answer:
        "It is mainly used in modular kitchens, cabinets, wardrobes, and storage furniture."
    },
    {
      question: "Is the height adjustable?",
      answer:
        "Yes, PVC Leg Light comes with an adjustable feature for proper cabinet leveling."
    },
    {
      question: "Is it moisture resistant?",
      answer:
        "Yes, the PVC material is resistant to moisture and corrosion."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed during cabinet or kitchen setup."
    }
  ]
},
 {
  code: "7133",
  name: "PVC DISH HOLDER",
  category: "kitchen Accessories",

  short:
    "PVC Dish Holder is a practical kitchen accessory designed to organize and store plates and dishes efficiently inside cabinets or on shelves. Made from high-quality PVC material, it is lightweight, durable, and resistant to moisture. It helps keep kitchen utensils neatly arranged while allowing easy access and proper drying of dishes.",

  features: [
    "Made from high-quality PVC material",
    "Helps organize plates and dishes neatly",
    "Lightweight yet durable for daily kitchen use",
    "Resistant to moisture and easy to clean",
    "Ideal for kitchen cabinets, shelves, and dish racks"
  ],

  /* ✅ PRICE */
  price: "₹2031",
  oldPrice: "₹2500",

  /* ✅ SKU + STOCK */
  sku: "7100",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg10,
  thumbnails: [thumb21, thumb22],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20Dish%20Holder",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "Dish Holder / Organizer" },
    { label: "Finish", value: "White / Transparent" },
    { label: "Application", value: "Kitchen Cabinets / Shelves / Dish Rack" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC Dish Holder", code: "7100", size: "", finish: "PVC" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a PVC Dish Holder?",
      answer:
        "It is a kitchen accessory used to organize and store plates and dishes inside cabinets or racks."
    },
    {
      question: "Where can PVC Dish Holder be used?",
      answer: "It is mainly used in kitchen cabinets, shelves, and dish racks."
    },
    {
      question: "Is PVC Dish Holder durable?",
      answer:
        "Yes, it is made from high-quality PVC which is lightweight, durable, and moisture-resistant."
    },
    {
      question: "Does it help in organizing dishes?",
      answer:
        "Yes, it keeps plates and dishes neatly arranged and easily accessible."
    },
    {
      question: "Is it easy to clean?",
      answer:
        "Yes, it can be easily cleaned with a damp cloth or mild detergent."
    }
  ]
},
 {
  code: "7134",
  name: "WIRE FITMENT WITH PVC GRIP",
  category: "kitchen Accessories",

  short:
    "Wire Fitment with PVC Grip is a durable and practical kitchen accessory designed to provide a secure and comfortable grip for wire baskets and pull-out systems. The sturdy metal wire structure combined with a PVC grip ensures better handling, stability, and long-lasting performance. It is ideal for modular kitchen storage units where smooth operation and easy access are required.",

  features: [
    "Strong metal wire construction for durability",
    "PVC grip for comfortable and secure handling",
    "Ideal for wire baskets and pull-out storage systems",
    "Enhances stability and usability of kitchen accessories",
    "Resistant to daily wear and moisture"
  ],

  /* ✅ PRICE */
  price: "₹540",
  oldPrice: "₹999",

  /* ✅ SKU + STOCK */
  sku: "7735",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg11,
  thumbnails: [thumb23, thumb24],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Wire%20Fitment%20with%20PVC%20Grip",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal Wire + PVC Grip" },
    { label: "Type", value: "Wire Fitment / Handle Grip" },
    { label: "Finish", value: "Chrome / PVC Coated" },
    { label: "Application", value: "Wire Baskets / Pull-Out Systems" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Wire Fitment with PVC Grip", code: "7635", size: "CUP", finish: "Metal + PVC" },
    { item: "Wire Fitment with PVC Grip", code: "7636", size: "PLATE", finish: "Metal + PVC" },
    { item: "Wire Fitment with PVC Grip", code: "7637", size: "THALI ", finish: "Metal + PVC" }

  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Wire Fitment with PVC Grip?",
      answer:
        "It is a wire accessory with a PVC grip designed to provide a secure handle for wire baskets and pull-out systems."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in modular kitchens with wire baskets and storage pull-out systems."
    },
    {
      question: "What is the benefit of the PVC grip?",
      answer:
        "The PVC grip provides a comfortable hold and improves handling while opening or pulling baskets."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, the strong metal wire construction ensures long-lasting performance."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily fitted with wire baskets and modular kitchen accessories."
    }
  ]
},


{
  code: "7135",
  name: "UNBREAKABLE CUTLERY TRAY",
  category: "kitchen Accessories",

  short:
    "Unbreakable Cutlery Tray is a durable and practical kitchen organizer designed to neatly store spoons, forks, knives, and other small utensils inside drawers. Made from high-quality unbreakable material, it offers long-lasting strength and resistance to daily wear. Its smart compartment design helps keep cutlery organized, easily accessible, and protected from damage, making it ideal for modular kitchen drawers.",

  features: [
    "Made from high-quality unbreakable material",
    "Designed to organize spoons, forks, knives, and utensils",
    "Multiple compartments for better organization",
    "Durable and resistant to daily wear and impact",
    "Ideal for modular kitchen drawers and cabinets",
    "Easy to clean and maintain"
  ],

  /* ✅ PRICE */
  price: "₹1449",
  oldPrice: "₹2000",

  /* ✅ SKU + STOCK */
  sku: "7629",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg12,
  thumbnails: [thumb25, thumb26],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/69TwpM9MgI4",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Unbreakable%20Cutlery%20Tray",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Unbreakable Plastic" },
    { label: "Type", value: "Cutlery Tray / Drawer Organizer" },
    { label: "Finish", value: "Matte / Smooth" },
    { label: "Application", value: "Kitchen Drawers / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Unbreakable Cutlery Tray", code: "7629", size: "450mm", finish: "Plastic" },
    { item: "Unbreakable Cutlery Tray", code: "7630", size: "500mm", finish: "Plastic" },
    { item: "Unbreakable Cutlery Tray", code: "7631", size: "600mm", finish: "Plastic" }
    ,{ item: "Unbreakable Cutlery Tray", code: "7632", size: "700mm", finish: "Plastic" },
    { item: "Unbreakable Cutlery Tray", code: "7633", size: "800mm", finish: "Plastic" },
    { item: "Unbreakable Cutlery Tray", code: "7634", size: "900mm", finish: "Plastic" },


  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Unbreakable Cutlery Tray?",
      answer:
        "It is a durable cutlery organizer used to store spoons, forks, knives, and other utensils in kitchen drawers."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in modular kitchen drawers and cabinets."
    },
    {
      question: "What is the advantage of unbreakable material?",
      answer:
        "It provides long-lasting durability and prevents damage from daily use."
    },
    {
      question: "Does it help organize utensils?",
      answer:
        "Yes, it has multiple compartments to keep different types of cutlery neatly arranged."
    },
    {
      question: "Is it easy to clean?",
      answer:
        "Yes, it can be easily cleaned with water or a damp cloth."
    }
  ]
},

 {
  code: "7136",
  name: "PVC CUTLERY",
  category: "kitchen Accessories",

  short:
    "PVC Cutlery is a practical kitchen drawer organizer designed to neatly store spoons, forks, knives, and other small utensils. Made from durable PVC material, it helps keep kitchen drawers tidy and organized while allowing easy access to everyday cutlery. Its multiple compartments ensure proper arrangement and prevent utensils from mixing or getting damaged.",

  features: [
    "Made from high-quality PVC material",
    "Designed to organize spoons, forks, knives, and utensils",
    "Multiple compartments for better arrangement",
    "Lightweight, durable, and moisture-resistant",
    "Ideal for modular kitchen drawers and cabinets",
    "Helps keep kitchen drawers neat and clutter-free"
  ],

  /* ✅ PRICE */
  price: "₹932",
  oldPrice: "₹1200",

  /* ✅ SKU + STOCK */
  sku: "7097",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg13,
  thumbnails: [thumb27, thumb28],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/MPNQ34MYKQg",

  /* ✅ BUTTON LINKS */
 catalogue: "/Slimline-Price-List.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20PVC%20Cutlery",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "PVC" },
    { label: "Type", value: "Cutlery Organizer" },
    { label: "Finish", value: "Matte / Smooth" },
    { label: "Application", value: "Kitchen Drawers / Cabinets" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "PVC Cutlery Organizer", code: "7097", size: "450mm", finish: "PVC" },
     { item: "PVC Cutlery Organizer", code: "7446", size: "500mm", finish: "PVC" },
      { item: "PVC Cutlery Organizer", code: "7098", size: "600mm", finish: "PVC" },
       { item: "PVC Cutlery Organizer", code: "7190", size: "700mm", finish: "PVC" },
        { item: "PVC Cutlery Organizer", code: "7191", size: "800mm", finish: "PVC" },
         { item: "PVC Cutlery Organizer", code: "7099", size: "900mm", finish: "PVC" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is PVC Cutlery?",
      answer:
        "PVC Cutlery is a drawer organizer used to store spoons, forks, knives, and other kitchen utensils."
    },
    {
      question: "Where can PVC Cutlery be used?",
      answer:
        "It is mainly used in modular kitchen drawers and cabinets."
    },
    {
      question: "What is the benefit of using a cutlery organizer?",
      answer:
        "It keeps utensils neatly arranged and easily accessible while preventing clutter."
    },
    {
      question: "Is PVC Cutlery durable?",
      answer:
        "Yes, it is made from durable PVC material that is lightweight and moisture-resistant."
    },
    {
      question: "Is it easy to clean?",
      answer:
        "Yes, it can be easily cleaned with water or a damp cloth."
    }
  ]
},
 {
  code: "7137",
  name: "SS WIRE FITMENT",
  category: "kitchen Accessories",

  short:
    "SS Wire Fitment is a strong and durable accessory designed for modular kitchen wire baskets and storage systems. Made from high-quality stainless steel, it provides excellent support and stability while ensuring long-lasting performance. Its corrosion-resistant construction makes it ideal for kitchen environments, helping keep storage units secure, organized, and easy to use.",

  features: [
    "Made from high-quality stainless steel (SS)",
    "Strong and durable construction for long-term use",
    "Provides secure support for wire baskets and storage units",
    "Corrosion and rust resistant",
    "Ideal for modular kitchens and cabinet systems",
    "Ensures stability and smooth operation of wire accessories"
  ],

  /* ✅ PRICE */
  price: "₹488",
  oldPrice: "₹999",

  /* ✅ SKU + STOCK */
  sku: "7378",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg14,
  thumbnails: [thumb29, thumb30],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20SS%20Wire%20Fitment",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel (SS)" },
    { label: "Type", value: "Wire Fitment / Support Accessory" },
    { label: "Finish", value: "Chrome / SS Finish" },
    { label: "Application", value: "Wire Baskets / Modular Kitchens" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "SS Wire Fitment", code: "7378", size: "CUP", finish: "SS" },
     { item: "SS Wire Fitment", code: "7379", size: "PLATE", finish: "SS" },
      { item: "SS Wire Fitment", code: "7380", size: "THALI", finish: "SS" },
     
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is SS Wire Fitment?",
      answer:
        "SS Wire Fitment is a stainless steel accessory used to support and secure wire baskets in modular kitchen storage systems."
    },
    {
      question: "Where can SS Wire Fitment be used?",
      answer:
        "It is mainly used in modular kitchens with wire baskets and cabinet storage units."
    },
    {
      question: "Is SS Wire Fitment rust-resistant?",
      answer:
        "Yes, it is made from stainless steel which is resistant to rust and corrosion."
    },
    {
      question: "Does it improve basket stability?",
      answer:
        "Yes, it helps provide strong support and stability for wire baskets."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed with modular kitchen wire basket systems."
    }
  ]
},

{
  code: "7138",
  name: "SILVER DISH RACK",
  category: "kitchen Accessories",

  short:
    "Silver Dish Rack is a practical kitchen accessory designed to store and organize plates, bowls, and dishes efficiently. Made with durable materials and a stylish silver finish, it provides a sturdy structure for holding utensils while allowing proper air circulation for quick drying. It helps keep kitchen cabinets or countertops neat and organized, making it ideal for modular kitchens.",

  features: [
    "Stylish silver finish for a clean and modern look",
    "Strong and durable construction",
    "Designed to store plates, bowls, and dishes neatly",
    "Allows proper air circulation for quick drying",
    "Ideal for modular kitchens and kitchen cabinets",
    "Helps keep the kitchen organized and clutter-free"
  ],

  /* ✅ PRICE */
  price: "₹1299",
  oldPrice: "₹1999",

  /* ✅ SKU + STOCK */
  sku: "7166-7170",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg15,
  thumbnails: [thumb31, thumb32],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/-LfENKCLvJo",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/Slimline Price List.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Silver%20Dish%20Rack",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Type", value: "Dish Rack / Storage Organizer" },
    { label: "Finish", value: "Silver Coated" },
    { label: "Application", value: "Kitchen Cabinets / Countertops" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Silver Dish Rack", code: "7166", size: "600MM", finish: "Silver" },
    { item: "Silver Dish Rack", code: "7167", size: "700MM", finish: "Silver" },
    { item: "Silver Dish Rack", code: "7168", size: "800MM", finish: "Silver" },
    { item: "Silver Dish Rack", code: "7169", size: "900MM", finish: "Silver" },
    { item: "Silver Dish Rack", code: "7170", size: "1000MM", finish: "Silver" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Silver Dish Rack?",
      answer:
        "It is a kitchen accessory used to store and organize plates, bowls, and dishes."
    },
    {
      question: "Where can Silver Dish Rack be used?",
      answer:
        "It can be used in modular kitchens, cabinets, or on countertops for dish storage."
    },
    {
      question: "Does it help dry dishes?",
      answer:
        "Yes, its open design allows proper air circulation for quick drying of dishes."
    },
    {
      question: "Is the rack durable?",
      answer:
        "Yes, it is made from strong materials with a durable silver finish."
    },
    {
      question: "Is it available in different sizes?",
      answer:
        "Yes, it is available in 600MM, 700MM, 800MM, 900MM, and 1000MM sizes."
    }
  ]
},

{
  code: "7139",
  name: "BLACK DISH RACK",
  category: "kitchen Accessories",

  short:
    "Black Dish Rack is a practical kitchen accessory designed to store and organize plates, bowls, and dishes efficiently. Made with durable materials and a stylish black finish, it provides a sturdy structure for holding utensils while allowing proper air circulation for quick drying. It helps keep kitchen cabinets or countertops neat and organized, making it ideal for modern modular kitchens.",

  features: [
    "Stylish black finish for a premium modern look",
    "Strong and durable construction",
    "Designed to store plates, bowls, and dishes neatly",
    "Allows proper air circulation for quick drying",
    "Ideal for modular kitchens and kitchen cabinets",
    "Helps keep the kitchen organized and clutter-free"
  ],

  /* ✅ PRICE */
  price: "₹2969",
  oldPrice: "₹3099",

  /* ✅ SKU + STOCK */
  sku: "7166-7170",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg16,
  thumbnails: [thumb33, thumb34],

  /* ✅ VIDEO */
  video: "https://youtu.be/umJ2oW-_t7A?si=oW7SdZAPPdfKaCVY",

  /* ✅ BUTTON LINKS */
  catalogue: "/catalogues/kitchen-accessories.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Black%20Dish%20Rack",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Type", value: "Dish Rack / Storage Organizer" },
    { label: "Finish", value: "Black Coated" },
    { label: "Application", value: "Kitchen Cabinets / Countertops" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Black Dish Rack", code: "7166", size: "600mm", finish: "Black" },
    { item: "Black Dish Rack", code: "7167", size: "700mm", finish: "Black" },
    { item: "Black Dish Rack", code: "7168", size: "800mm", finish: "Black" },
    { item: "Black Dish Rack", code: "7169", size: "900mm", finish: "Black" },
    { item: "Black Dish Rack", code: "7170", size: "1000mm", finish: "Black" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Black Dish Rack?",
      answer:
        "It is a kitchen accessory used to store and organize plates, bowls, and dishes."
    },
    {
      question: "Where can Black Dish Rack be used?",
      answer:
        "It can be used in modular kitchens, cabinets, or on countertops for dish storage."
    },
    {
      question: "Does it help dry dishes?",
      answer:
        "Yes, its open design allows proper air circulation for quick drying of dishes."
    },
    {
      question: "Is the rack durable?",
      answer:
        "Yes, it is made from strong materials with a durable black finish."
    },
    {
      question: "Is it available in different sizes?",
      answer:
        "Yes, it is available in 600MM, 700MM, 800MM, 900MM, and 1000MM sizes."
    }
  ]
},

{
  code: "7140",
  name: "AUTO LID BIN",
  category: "kitchen Accessories",

  short:
    "Auto Lid Bin is a smart and hygienic waste management solution designed for modern kitchens. It features an automatic lid opening mechanism that allows hands-free operation, making waste disposal easy and convenient. Built with durable materials, it helps maintain cleanliness while preventing odors from spreading, making it ideal for modular kitchen cabinets and workspaces.",

  features: [
    "Automatic lid opening system for hands-free use",
    "Hygienic and convenient waste disposal solution",
    "Durable construction for long-lasting performance",
    "Odor control with closed lid design",
    "Ideal for modular kitchens and cabinets",
    "Keeps kitchen spaces clean and organized"
  ],

  /* ✅ PRICE */
  price: "₹1499",
  oldPrice: "₹2200",

  /* ✅ SKU + STOCK */
  sku: "7140",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: mainImg17,
  thumbnails: [thumb35, thumb36],

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ BUTTON LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Auto%20Lid%20Bin",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "High Quality Plastic / SS (varies by model)" },
    { label: "Type", value: "Auto Lid Waste Bin" },
    { label: "Mechanism", value: "Automatic Lid Opening System" },
    { label: "Application", value: "Modular Kitchen / Cabinets / Workspaces" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Auto Lid Bin", code: "7140", size: "Standard", finish: "White/Grey" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is an Auto Lid Bin?",
      answer:
        "It is a waste bin with an automatic lid mechanism that opens for easy and hygienic waste disposal."
    },
    {
      question: "Where can Auto Lid Bin be used?",
      answer:
        "It is commonly used in modular kitchens, cabinets, and workspaces."
    },
    {
      question: "What is the benefit of the automatic lid?",
      answer:
        "The automatic lid allows hands-free operation and helps maintain hygiene."
    },
    {
      question: "Does it help control odor?",
      answer:
        "Yes, the lid helps keep the bin closed and prevents bad odors from spreading."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed in modular kitchen cabinets or under-sink areas."
    }
  ]
}
];
